import styled from 'styled-components';

export const StyledDiseaseItemList = styled.span`
   display: flex;
   flex-wrap: wrap;
`;

StyledDiseaseItemList.displayName = 'StyledDiseaseItemList';
